module.exports = __webpack_public_path__ + "img/visa.5c644b93.png";